@if (vm$ | async; as vm) {
	<section class="coverage flex container">
		<div class="wrap-title flex">
			<img class="padlock" src="assets/images/ico-padlock.svg" alt="padlock" />
			<h1 class="text title">Ingresa el código de verificación</h1>
			<h2 class="text subtitle">
				Verifica el número de teléfono, ingresando el código que enviamos por SMS al
				<span>**{{ vm.otp.hiddenTarget }}**</span>
			</h2>
		</div>

		<form [formGroup]="otpForm" class="wrap-otp flex">
			<div formArrayName="digits">
				@for (ctrl of digits.controls; track $index) {
					<input
						class="digit text"
						type="text"
						inputmode="numeric"
						autocomplete="one-time-code"
						[formControlName]="$index"
						appAutoFocus
						[appAutoFocusIndex]="$index"
						[appAutoFocusMax]="digits.length"
					/>
				}
			</div>
		</form>

		<div class="wrap-text flex">
			<span class="text time"> {{ vm.timer }} tiempo restante </span>

			<button bciWkButtonWithIcon [disabled]="vm.loaderButton" (click)="onUpdatePhone()">
				Editar número de teléfono
			</button>
			<button
				bciWkButtonWithIcon
				[isLoading]="vm.loaderButton"
				[disabled]="!vm.expired || vm.loaderButton"
				(click)="onResendOtp(vm.customerData.companyRut, vm.expired)"
			>
				Reenviar código
			</button>
		</div>
		<div class="wrap-button flex">
			<button
				bciWkButtonPrimary
				[disabled]="otpForm.invalid || vm.expired"
				(click)="
					onValidateOtp(
						vm.customerData.companyRut,
						vm.expired,
						vm.journeyMetadata,
						vm.parameters.simulatorUrl
					)
				"
			>
				Continuar
			</button>
		</div>
	</section>
}
